import Axios from "axios";
import {
  SET_LC_EXPORT_LC_MASTER_LIST,
  UNSET_LC_EXPORT_LC_MASTER_LIST,
  SET_EDITING_LC_EXPORT_LC_MASTER,
  UNSET_EDITING_LC_EXPORT_LC_MASTER,
} from "@/store/mutation-types";
import {
  saveUpdateLcExportLcMaster,
  getLcExportLcMasterList,
  getLcExportLcMasterById as getLcExportLcMasterByIdApi,
} from "@/store/api";

// initial state
const state = {
  lcExportLcMasterList: [],
  editingLcExportLcMaster: null,
};

const getters = {
  getLcExportLcMasterList(state) {
    return state.lcExportLcMasterList;
  },
  getEditingLcExportLcMaster(state) {
    return state.editingLcExportLcMaster;
  },
};

const mutations = {
  [SET_LC_EXPORT_LC_MASTER_LIST](state, data) {
    state.lcExportLcMasterList = data;
  },
  [UNSET_LC_EXPORT_LC_MASTER_LIST](state) {
    state.lcExportLcMasterList = [];
  },
  [SET_EDITING_LC_EXPORT_LC_MASTER](state, data) {
    state.editingLcExportLcMaster = data;
  },
  [UNSET_EDITING_LC_EXPORT_LC_MASTER](state) {
    state.editingLcExportLcMaster = null;
  },
};

const actions = {
  saveUpdateLcExportLcMaster({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcExportLcMaster, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcExportLcMasterList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcExportLcMasterList)
        .then(function (response) {
          commit(SET_LC_EXPORT_LC_MASTER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch(function (error) {
          commit(UNSET_LC_EXPORT_LC_MASTER_LIST);
          reject(error);
        });
    });
  },

  getLcExportLcMasterById({ commit }, id) {
    const url = `${getLcExportLcMasterByIdApi}${id}`;
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.get(url)
        .then((response) => {
          commit(SET_EDITING_LC_EXPORT_LC_MASTER, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

